import { useAuth } from "@/lib/Auth/useAuth";
import { useOrgId } from "@/lib/GraphQLCodegen/fetcher";

/**
 * Active organisation, derived entirely from the URL — the source of truth.
 * The scoped path param (`/$tenant/$orgId/...`, plus the
 * `/org/$orgId/create-supplier` flow) drives it everywhere. The matched
 * record comes from the auth `organisations` list (undefined while it loads or
 * when the org isn't one of the user's memberships).
 */
export function useActiveOrganisation() {
  const { organisations } = useAuth();
  const activeOrganisationId = useOrgId();
  const activeOrganisation = organisations.find(
    (org) => String(org.id) === activeOrganisationId,
  );

  return { activeOrganisationId, activeOrganisation };
}
